import Vue from 'vue'
import {setAegis,getDetectVideoUrl } from '@/api/project'
import {getBrowse } from '@/api/user'
import Hls from 'hls.js'
import { EXCLUDED_URLS } from './constants'
const vm = new Vue()

export function convertToChinaNum(num) {
    var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];//可继续追加更高位转换值
    if (!num || isNaN(num)) {
        return "零";
    }
    var english = num.toString().split("")
    var result = "";
    for (var i = 0; i < english.length; i++) {
        var des_i = english.length - 1 - i;//倒序排列设值
        result = arr2[i] + result;
        var arr1_index = english[des_i];
        result = arr1[arr1_index] + result;
    }
    //将【零千、零百】换成【零】 【十零】换成【十】
    result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
    //合并中间多个零为一个零
    result = result.replace(/零+/g, '零');
    //将【零亿】换成【亿】【零万】换成【万】
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
    //将【亿万】换成【亿】
    result = result.replace(/亿万/g, '亿');
    //移除末尾的零
    result = result.replace(/零+$/, '')
    //将【零一十】换成【零十】
    //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
    //将【一十】换成【十】
    result = result.replace(/^一十/g, '十');
    return result;
}

export function getUrlParam(urlStr, urlKey) {
    const url = new URL(urlStr) // 字符串转换成url格式
    const paramsStr = url.search.slice(1) // 获取'?'后面的参数字符串
    const paramsArr = paramsStr.split('&') // 分割'&'字符 获得参数数组
    for (let i = 0; i < paramsArr.length; i++) {
        const tempArr = paramsArr[i].split('=')
        if (tempArr[0] === urlKey) {
            return tempArr[1]
        }
    }
}

async function setAegisFunc(params) {
    try {
        console.log('setAegisFunc  start...');
        const {code,message} = await setAegis(params)
        console.log('setAegisFunc  result:');
        
        if (code !== 200) {
             console.error(`埋点错误：${message}`);
        }
    } catch (error) {
        console.error(`埋点错误：${error}`);
    }
}

export async function aegis(params) {
    const userinfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    console.log('setAegisFunc  before', );
    
    await setAegisFunc({
        click_area:params.clickarea ?? '',
        click_type:params.clicktype ?? '',
    })
    console.log('setAegisFunc  end', );
    
    if (Object.keys(userinfo)?.length) {
        const integrated = {
            RoleName: userinfo?.nickname ?? '',
            vHeadUrl: userinfo?.avatar ?? '',
            State: userinfo?.muted ? 2 : 1,
            //   clickarea: 'awards',
            //   clicktype: type, // 视频播放1/开始创作2/开始使用梦工坊3/社区4/文档5/视频学堂6
            devtype: userinfo?.loginData?.authType ?? 0,
            devstate: userinfo?.loginData?.devStat ?? 0,
            adminid: userinfo?.admin_group_id,
            adminname: userinfo?.admin_group_name ?? '',
            regdate: userinfo?.register_time ?? 0,
            ...params
        }
        console.log('vm.$aegis', vm.$aegis);
        // Playerclick
        vm.$aegis.report({
            msg: 'Playerclick',
            ext1: String(params?.clicktype), // 视频播放1/开始创作2/开始使用梦工坊3/社区4/文档5/视频学堂6,播放视频 7
            ext2: userinfo?.muted ? '2' : '1', //账号状态
            ext3: JSON.stringify(integrated), //
            // trace: 'trace',
        })
        console.log('Playerclick');
        
    } else {
        // 游客
        // Playerclick
        vm.$aegis.report({
            msg: 'Playerclick',
            ext1: String(params?.clicktype), // 视频播放1/开始创作2/开始使用梦工坊3/社区4/文档5/视频学堂6
            ext2: '0', //点击区域
            //   ext3: 0, //账号状态 0 游客
        })
    }
}

 
export function getChatRequestRoot(envStatus) {
    const Ticket = {
        // 轻游戏开发者中心测试环境
        'minicreate.': 'https://wxup-hosting-test.game.qq.com',
        // 轻游戏开发者中心正式环境
        'qyx.': 'https://wxup-hosting-pub.game.qq.com',
        'dream.': 'https://wxup-hosting-pub.game.qq.com',
        // 轻游戏EA环境
        'ea.dream.': 'https://wxup-hosting-pub.game.qq.com',
        // 外部传入环境
        '1': 'https://wxup-hosting-test.game.qq.com',
        '2': 'https://wxup-hosting-pre.game.qq.com',
        '3': 'https://wxup-hosting-eapre.game.qq.com',
        '4': 'https://wxup-hosting-ea.game.qq.com',
        '5': 'https://wxup-hosting-pub.game.qq.com',
    };
    if (envStatus) {
        return Ticket[envStatus];
    }
    const key = Object.keys(Ticket).find(key => location.host.startsWith(key))
    if (key) {
        return Ticket[key]
    }
}

export function getOtherTicketFlag() {
    const Ticket = {
        // 轻游戏开发者中心预发布环境
        'minicreate': 'minipre-Ticket',
        // 轻游戏开发者中心EA环境
        'qyx': 'qyxea-Ticket',
        'dream': 'qyxea-Ticket',
        // 轻游戏正式环境
        'ea.dream': 'minicreate-Ticket',
    };
    const key = Object.keys(Ticket).find(key => location.host.startsWith(key))
    if (key) {
        return Ticket[key]
    }
}

export function getTicketFlag() {
    const Ticket = {
        // 轻游戏开发者中心测试环境
        'minicreate': 'minitest-Ticket',
        // 轻游戏开发者中心正式环境
        'qyx': 'minicreate-Ticket',
        'dream': 'minicreate-Ticket',
        // 轻游戏EA环境
        'ea.dream': 'qyxea-Ticket',
    };
    const key = Object.keys(Ticket).find(key => location.host.startsWith(key))
    if (key) {
        console.log(Ticket[key]);
        return Ticket[key]
    }
}

export function getJumpLink() {
    const Ticket = {
        // 轻游戏开发者中心测试环境
        'minicreate': 'https://dev.minicreate.qq.com/#/',
        // 轻游戏开发者中心正式环境
        'qyx': 'https://dev.dream.qq.com/#/',
        'dream': 'https://dev.dream.qq.com/#/',
        // 轻游戏EA环境
        'ea.dream': 'https://eadev.dream.qq.com/#/',
    };
    const key = Object.keys(Ticket).find(key => location.host.startsWith(key))
    if (key) {
        console.log(Ticket[key]);
        return Ticket[key]
    }
}

export function confirmCarryVerification() {
    /*
        优化的URL参数解析逻辑：
        1. 支持hash中的参数（如 #/?token=xxx&redirect_url=xxx）
        2. 正确处理 redirect_url 值中包含 # 的情况
        3. 自动进行URL解码
    */
    const url = location.href;
    const result = {};
    
    // 提取查询字符串（支持 ? 和 #/? 两种格式）
    let queryString = '';
    
    // 处理 hash 中的参数（如 #/?token=xxx）
    const hashMatch = url.match(/#\/\?([\s\S]+)$/);
    if (hashMatch) {
        queryString = hashMatch[1];
    } else {
        // 处理普通查询参数（如 ?token=xxx）
        // 注意：不能简单地用 # 判断结束，因为 redirect_url 值中可能包含 #
        const queryMatch = url.match(/\?([\s\S]+)$/);
        if (queryMatch) {
            queryString = queryMatch[1];
        }
    }
    
    // 手动解析参数，正确处理 redirect_url 值中的 #
    if (queryString) {
        // 清理换行符
        queryString = queryString.replace(/\r?\n\s*/g, '');
        
        // 提取 ticket 参数
        const ticketMatch = queryString.match(/ticket=([^&]+)/);
        if (ticketMatch) {
            result.ticket = ticketMatch[1];
        }
        
        // 提取 token 参数
        const tokenMatch = queryString.match(/token=([^&]+)/);
        if (tokenMatch) {
            result.token = tokenMatch[1];
        }
        
        // 提取 redirect_url 参数（redirect_url= 后面到字符串结尾的内容）
        // 由于 redirect_url 值中可能包含 #，所以取到结尾
        const redirectUrlIndex = queryString.lastIndexOf('redirect_url=');
        if (redirectUrlIndex !== -1) {
            result.redirect_url = queryString.substring(redirectUrlIndex + 'redirect_url='.length);
        }
    }
    if (result.ticket) {
        return {
            ticket: result.ticket,
        };
    }
    if (result.token && result.redirect_url) {
        return {
            token: result.token,
            redirect_url: decodeURIComponent(result.redirect_url),
        };
    } else {
        return false;
    }
}


/**
 * 社区 添加图片放大、a标签添加新开页跳转、视频添加播放按钮和隐藏下载
 * @param {*} params 
 */
export async function handleRichtextEle(ele) {
  let imgArr=[]
  if(!ele){
    imgArr = document.querySelectorAll('.community_post_container img') ??[]
  }else{
    imgArr = ele?.querySelectorAll('img')?? [] 
  }
  const imgList = Array.from(imgArr).map(i => i?.src || '').filter(Boolean);
  for (let i = 0; i < imgArr.length; i++) {
    if(imgArr[i].alt==='emoji-image') continue
    imgArr[i].title = '图片可点击放大'
    imgArr[i].style.cursor = 'pointer'
    imgArr[i].addEventListener('click', () => {
      vm.$hevueImgPreview({
        multiple: true,
        keyboard:true,
        nowImgIndex: i,
        imgList,
        clickMaskCLose: true,
      })
    })
  }

  // a标签添加新开页面跳转
  const links = document.querySelectorAll('.community_post_container a')
  links.forEach((item) => {
    if (!item.href.includes('#')) {
      item.target = '_blank'
    }
  })

  // 视频去除下载 和添加播放按钮
  const videoArr = document.getElementsByTagName('video');

  for (let i = 0; i < videoArr.length; i++) {
    // videoArr[i].setAttribute('controls', undefined)

    videoArr[i].setAttribute('controlsList', 'nodownload')
    videoArr[i].setAttribute('oncontextmenu', 'return false')
    videoArr[i].style.width = '100%'
    // videoArr[i].style.objectFit='cover'
    //  videoArr[i].style.display = 'none'
    const parent = videoArr[i].parentElement;
    parent.style.position = 'relative'
    const div = document.createElement('div');
    div.className = 'w-video-play-btn';
    div.innerHTML = `<svg width="65" height="65" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#333" stroke="#333" stroke-width="4" stroke-linejoin="round"/><path d="M20 24V17.0718L26 20.5359L32 24L26 27.4641L20 30.9282V24Z" fill="#FFF" stroke="#FFF" stroke-width="4" stroke-linejoin="round"/></svg>`

    parent.appendChild(div)

    videoArr[i].addEventListener('pause', () => {
      // div.style.display = 'block';
      parent.classList.remove('videoPlay')
      parent.classList.add('hiddenPlay')
    })
    videoArr[i].addEventListener('play', () => {
      parent.classList.remove('hiddenPlay')
      parent.classList.add('videoPlay')
    })
    let src = videoArr[i]?.children[0]?.src ?? videoArr[i]?.src ?? '';
    const code = getURLParam(src,'code')
    console.log('code',code);
      if (code) {
          const res = await getDetectVideoUrl({ code });
          if (res?.data?.cdn_url) {
              src = res.data.cdn_url;
              if (Hls.isSupported() && isM3U8(src)) {
                  const hls = new Hls();
                  hls.loadSource(src);
                  hls.attachMedia(videoArr[i]);
                  // hls.on(Hls.Events.MANIFEST_PARSED, function () {
                  //   videoArr[i].play();
                  // });
              }

          }
      }
   
    console.log('src', src, videoArr[i].children);

    div.onclick = () => {
        //    player.play();
        videoArr[i].play();
        parent.classList.remove('hiddenPlay')
        parent.classList.add('openVideo', 'videoPlay')
    }

    //   videoPlay.play({url:src})
  }

}

function isM3U8(url) {
  const regex = /\.m3u8/i; // 使用 i 标志来忽略大小写
  return regex.test(url);
}

export const isProd = () => {
    return location.host.startsWith('qyx.qq.com') || location.host.startsWith('dream.qq.com')
}


export const getDevMainpage = () => {
    // return 'dev.dream.qq.com'
    return 'dev.dream.qq.com'
}

export const getDevEAMainpage = () => {
    // return 'eadev.dream.qq.com'
    return 'eadev.dream.qq.com'
}

import { getToken } from '@/utils/auth'

export const needLogin = () => {
  // console.log(getToken(),'token~~~~~~~~~~~~~~');
  if (getToken()) {
    return false
  } else {
    if (!isMobile()) {
      window.location.href = `/#/oauth?app_id=5012568a421eeb0b&redirect_url=${location.href}`  
    }
    return true
  }
}

export const isMobile = () => {
     const flag= /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
     return flag || document.documentElement.clientWidth < 768
}

// 修改html字体大小
export const  handleHtmlFront = () => {
 function setHtmlFontSize() { 
    const html = document.documentElement;
    let designWidth = 2560; // todo
    if (isMobile()) {
       designWidth = 750;
       html.style.fontSize = html.clientWidth / designWidth * 100 + "px";
    }
  }
  setHtmlFontSize()
  window.addEventListener('resize', ()=>{
    let timer;
    clearTimeout(timer);
    timer = setTimeout(setHtmlFontSize, 300);
});
}

// 下载 
export const downloadFile=(url)=> {
  console.log("downloadFile start");
  
   const link = document.createElement("a");
   link.href = url;
   const fliename = url.split("/").pop();
   link.download = fliename;
   document.body.appendChild(link);
   console.log('before click');
   
   link.click();
   console.log('after click');
   
   document.body.removeChild(link); 
   console.log("downloadFile end");
 }

 /**
 * 监听软键盘弹起与收起
 * @param {Function} onShow 键盘弹起回调
 * @param {Function} onHide 键盘收起回调
 * @returns {Function} 取消监听的函数
 */
export function listenKeyboard(onShow, onHide) {
    // vm.$message.info('listenKeyboard')
  // 1. 优先使用 VisualViewport API（现代浏览器推荐）
//   if (window.visualViewport) {
//     // vm.$message.info('visualViewport')
//     const handler = () => {
//          vm.$message.info(`visualViewport ${window.visualViewport.height}  ${window.innerHeight}`)
//       // 可视区域高度变化阈值（通常键盘高度 > 200px）
//       const isKeyboardOpen = window.visualViewport.height < window.innerHeight - 200;
//       isKeyboardOpen ? onShow?.() : onHide?.();
//     };
    
//     window.visualViewport.addEventListener('resize', handler);
//     return () => window.visualViewport.removeEventListener('resize', handler);
//   }

  // 2. Android 备用方案：窗口大小变化监听
  let windowHeight = window.innerHeight;
  const resizeHandler = () => {
    const newHeight = window.innerHeight;
    // 高度减少超过键盘最小阈值（150px）视为弹起
    if (newHeight < windowHeight - 150) {
      onShow?.();
    } 
    // 高度恢复且超过初始高度的90%视为收起
    else if (newHeight > windowHeight * 0.9) {
      onHide?.();
    }
    windowHeight = newHeight;
  };

  // 3. iOS 备用方案：焦点事件监听
  let focusTime = 0;
  const focusHandler = () => {
    focusTime = Date.now();
    onShow?.();
  };
  const blurHandler = () => {
    // iOS 键盘收起有延迟，避免误触发
    setTimeout(() => {
      if (Date.now() - focusTime > 100) onHide?.();
    }, 100);
  };

  // 添加监听
  window.addEventListener('resize', resizeHandler);
  document.addEventListener('focusin', focusHandler);
  document.addEventListener('focusout', blurHandler);

  // 返回清除监听函数
  return () => {
    window.removeEventListener('resize', resizeHandler);
    document.removeEventListener('focusin', focusHandler);
    document.removeEventListener('focusout', blurHandler);
  };
}

/**
 * 截断富文本内容
 * 
 * 该函数用于截断给定的富文本（HTML），使其字符数不超过指定限制
 * 它会尽量保留文本、图片和表情包等内容，直到达到字符限制为止
 * 
 * @param {string} html - 输入的富文本（HTML）字符串
 * @param {number} maxChars - 最大字符限制，包括文本、图片和表情包等所有内容
 * @param {boolean} needShowPic - 是否显示图片，如果为true，则图片会被保留（如果在字符限制内）
 * @param {boolean} needShowUrl - 是否显示链接，如果为true，则链接会被保留（如果在字符限制内）
 * @returns {object} - 返回一个对象，包含截断后的HTML内容、文本字符数、图片数、表情包数、总字符数和是否达到限制
 */
export function truncateRichText(html,maxChars,config) {
    const {needShowPic,needShowUrl,imgChar,imgCount=1} = config ?? {}
    
    // console.log('html maxChars', maxChars)
    const tempDiv = document.createElement('span');
    tempDiv.innerHTML = html;

    let currentChars = 0;
    let textChars = 0;  // 文字个数
    let imageCount = 0; // 图片个数
    let emoji1Count = 0; // 表情包1
    let emoji2Count = 0; //  表情包2
    let videoCount = 0; // 视频个数

    const resultDiv = document.createElement('span');
    let reachedLimit = false;

    function processNode(node) {
        if (reachedLimit) return;
        // console.log('node', node.className);

        // 处理文本节点
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            const remaining = maxChars - currentChars;

            if (text.length <= remaining) {
                // 整个文本节点都在限制内
                resultDiv.appendChild(document.createTextNode(text));
                currentChars += text.length;
                textChars += text.length;
            } else {
                // 只取部分文本
                resultDiv.appendChild(document.createTextNode(text.substring(0, remaining)));
                textChars += remaining;
                currentChars += remaining;
                reachedLimit = true;
            }
            return;
        }

        // 处理元素节点
        if (node.nodeType === Node.ELEMENT_NODE) {
            // 处理图片和表情包
            if (node.tagName === 'IMG') {
                let charValue = 0;
                let isEmoji = false;

                if (node.alt === 'emoji-image' || node.className.includes('emoji-img-show') || node.src.includes('https://game.gtimg.cn/images/datamore/cp/cc/emoj/DM_')) {
                    if ( node.src.includes('/malou')) {
                        charValue = 6;
                        emoji2Count++;
                    } else {
                        charValue = 2;
                        emoji1Count++;
                    }
                    isEmoji = true
                } else {
                    charValue = imgChar ?? 0; // 回复的a标签也会走到这里来
                    imageCount++;
                }

                if (currentChars + charValue <= maxChars) {
                    if (isEmoji || (needShowPic && imageCount<=imgCount)) {
                      const clone = node.cloneNode(true);
                      if (isEmoji) clone.style.display = "inline-block"; // 表情包变为内元素
                      resultDiv.appendChild(clone);
                      currentChars += charValue;
                    }
                    // console.log('html currentChars',currentChars);

                } else  {
                    reachedLimit = true;
                }
                return;
            }

            if ((node.tagName === 'A' && needShowUrl)) {
              const clone = node.cloneNode(true);
              resultDiv.appendChild(clone);
            }

            if (node.tagName === 'VIDEO') {
              videoCount++
            }

            // 处理其他元素（递归处理子节点）
            // const clone = node.cloneNode(false); // 浅拷贝（不含子节点）
            // resultDiv.appendChild(clone);

            for (const child of node.childNodes) {
                processNode(child);
                if (reachedLimit) break;
            }

            return;
        }
    }
    // 处理除了文字、图片和表情包的内容  
    function handleOtherHtmlContent(node) { 
        if (reachedLimit) return;
         // 处理元素节点 
        if (node.nodeType === Node.ELEMENT_NODE){
            if (['TABLE','FORM','IFRAME'].includes(node.tagName)) { // 可以继续加需要处理的标签
                reachedLimit = true;
                return;
            }
        }
        for (const child of node.childNodes) {
             handleOtherHtmlContent(child);
             if (reachedLimit) break;
         }
         return;
     }

    // 处理所有子节点
    for (const child of tempDiv.childNodes) {
        processNode(child);
        if (reachedLimit) break;
    }
    // // 另外判断一下是否需要收起 
    for (const child of tempDiv.childNodes) {
        handleOtherHtmlContent(child);
        if (reachedLimit) break;
    }

    if (imageCount > 1 || videoCount > 1 || imageCount+videoCount>=2) reachedLimit = true; // 图片和视频数大于1时或者图片和视频数加起来大于1时，认为达到限制

    const totalChars = currentChars;
    if (reachedLimit) {
        resultDiv.innerHTML += '...';
    }
    // console.log('totalChars', totalChars);
    // console.log('resultDiv.innerHTML',resultDiv.innerHTML);
    
    return {
        content: resultDiv.innerHTML,
        textChars,
        imageCount,
        emoji1Count,
        emoji2Count,
        totalChars,
        reachedLimit
    };
}

// 新增函数：解析 URL 查询参数并获取指定字段的值
function getURLParam(url, param) {
  const search = new URL(url).search;
  const params = new URLSearchParams(search);
  return params.get(param);
}


   // 根据时间戳计算剩余时间
   export function calculateRemainingTime(endTimestamp) {
      const now = Math.floor(Date.now() / 1000); // 当前时间戳（秒）
      const end = endTimestamp; // 结束时间戳（秒）
      
      if (end <= now) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }
      
      let remainingSeconds = end - now;
      
      const days = Math.floor(remainingSeconds / (24 * 60 * 60));
      remainingSeconds %= 24 * 60 * 60;
      
      const hours = Math.floor(remainingSeconds / (60 * 60));
      remainingSeconds %= 60 * 60;
      
      const minutes = Math.floor(remainingSeconds / 60);
      const seconds = remainingSeconds % 60;
      
      return {
        days,
        hours,
        minutes,
        // seconds
      };
    }

    // 后端页面埋点
export async function requestGetBrowse(to) {
  // console.log('to',to);
  
  // 排除特定URL（使用公共排除列表）
  const fullUrl = window.location.origin + '/#' + to.fullPath;
  if (isExcludedUrl(fullUrl)) {
    return;
  }
  
  // 未登录状态下，禁止特定页面的上报
  if (!getToken()) {
    const path = to.path;
    if (path.includes('/assistant') || path.includes('/forum/search')) {
      console.log('[requestGetBrowse] 未登录状态，禁止上报:', path);
      return;
    }
  }
  
  const targetList = ["/home", "/forum", "/wiki", "/learn",'/awards','/assistant',];
  const targetIndex = targetList.findIndex(item => to.path.includes(item))
  if (targetIndex !== -1) {
    // requestGetBrowse({ browse_module: targetIndex, browse_url: to.fullPath })
    const search_id = localStorage.getItem('searchId');
    localStorage.removeItem('searchId');
    // console.log(window.location.origin + '/#' + to.fullPath ,'~~~~~~~~~~~~');
    
    await getBrowse({ browse_module: targetIndex, browse_url:window.location.origin + '/#' + to.fullPath ,search_id }).then(res => {
      if (res.code === 200) {
        // console.log('埋点成功');
      } else {
        // console.log('埋点失败');
        vm.$message.error(res.message)
      }
    }).catch(err => { vm.$message.error(err.message) })
  }

}

//新开页跳转
export function openNewPage(url) {
  //检查是否支持 window.open 方法
  if (typeof window.open !== "function") {
    console.warn("浏览器不支持 window.open 方法，将在当前页面打开。");
    window.location.href = url;
    return;
  }
  

  const newWindow = window.open(url, "_blank");
  //检查窗是否被成功打开（例如，用户是否阻止了新窗口的打开）
  if (newWindow === null || typeof newWindow === "undefined") {
    console.warn("浏览器阻止了新窗口的打开，将在当前页面打开。");
    window.location.href = url;
    return;
  }
  //检查新窗口是否已经加载完成（例如，是否已经跳转到指定页面）
  try {
    
    if (newWindow.location.href === "about:blank" || newWindow.closed) {
      newWindow.location.href = url;
    }
  } catch (error) {
    console.warn("无法访问新窗口，将在当前页面打开:" + error);
    // 如果因同源策略等问题无法设置新窗口地址，则关闭无效新窗口并在当前页打开
    if (!newWindow.closed && newWindow) {
      newWindow.close();
    }
    window.location.href = url;
    return;
  }
  // 尝试关闭无效新窗口（例如，用户在弹窗出现前就点击了链接）
  try {
    newWindow.opener = null;
  } catch (error) {
    console.warn("无法设置新窗口的 opener 属性:" + error);
    newWindow.close();
    window.location.href = url;
    return;
  }
  
  // 尝试聚焦新窗口
  try {
    newWindow.focus();
  } catch (error) {
    console.warn("无法聚焦新窗口:" + error);
  }
}

// 检查 URL 是否在排除列表中
export function isExcludedUrl(url) {
  // 提取路径部分（去掉 origin 和 hash）
  const path = url.replace(window.location.origin + '/#', '');
  // 检查是否在排除列表中
  return EXCLUDED_URLS.some(excludedPath => path === excludedPath);
}
